<div class="px-4 flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-muted-foreground">
  <a href="#" class="hover:underline">Terms of Service</a>
  <a href="#" class="hover:underline">Privacy Policy</a>
  <a href="#" class="hover:underline">About</a>
  <span>© 2025 TruthShorts</span>
</div>
